import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React from "react";
import { Link } from "react-router-dom";

function DescriptionSigninText({ isMobile }) {
  return (
    <MDBox display="flex" alignItems="center" gap="6px">
      <MDTypography
        sx={{
          color: isMobile ? "#fff !important" : "#757575",
          fontWeight: "regular",
          fontSize: "14px",
          margin: "0px",
        }}
      >
        Don’t have an account?
      </MDTypography>

      <Link to="/sign-up" style={{ display: "flex" }}>
        <MDTypography
          component="span"
          fontWeight="medium"
          sx={{
            textDecoration: "underline !important",
            fontSize: "14px",
            color: isMobile ? "#fff" : "#0E361C",
          }}
        >
          Sign up
        </MDTypography>
      </Link>
    </MDBox>
  );
}

export default DescriptionSigninText;
